import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';


const Landing = () => {
  const navigate = useNavigate();
  const auth = localStorage.getItem('easydev');
  useEffect(() => {
    const auth = localStorage.getItem('easydev');
    if (auth) {
      navigate('/revenue');
    } else {
      navigate('/login');
    }
  }, [navigate]);

  return (
    <div className="landing" />
  );
};

export default connect(state => ({ theme: state.theme }))(Landing);
